import { useEffect, useState } from "react";
import SiteLayout from "@/components/site/SiteLayout";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import useSeo from "@/lib/useSeo";

export default function AcceptedCards() {
  useSeo({
    title: "Gift Cards We Buy — 100+ Accepted Brands | GC Nexon",
    description: "Complete list of gift card brands GC Nexon accepts, organized by category. See rates for Amazon, Walmart, Target, Apple, Steam, PlayStation, Uber, and more.",
    path: "/accepted-cards",
  });
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)); }, []);
  const byCat = brands.reduce((acc, b) => { (acc[b.category] = acc[b.category] || []).push(b); return acc; }, {});

  return (
    <SiteLayout>
      <section className="section-py container-x">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase mb-4">Accepted cards</span>
        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight">{brands.length} accepted brands.</h1>
        <p className="mt-4 text-muted-foreground text-lg">Organized by category so you can find yours fast.</p>

        <div className="mt-14 space-y-12">
          {Object.entries(byCat).map(([cat, list]) => (
            <div key={cat}>
              <h2 className="text-2xl font-extrabold capitalize mb-4">{cat}</h2>
              <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-3">
                {list.map((b) => (
                  <Link key={b.id} to={`/submit?brand=${encodeURIComponent(b.name)}`} className="card-soft p-4 hover:-translate-y-0.5 hover:shadow-md" style={{ transition: "transform .2s ease, box-shadow .2s ease" }}>
                    <div className="font-extrabold">{b.name}</div>
                    <div className="text-sm text-primary font-bold">up to {b.rate_percent}%</div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </SiteLayout>
  );
}
